import styled from 'styled-components/macro'
import Text from 'components/shared/Text'
import { respondAbove } from 'styles/mediaQueries'
import splashLeft from 'assets/images/decors/splashLeft.svg'
import splashRight from 'assets/images/decors/splashRight.svg'

export const HeaderDecor = styled(Text)`
    @media ${respondAbove.xl} {
        ::before,
        ::after {
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 35px;
            content: '';
            background-size: 20px 35px;
        }
        ::before {
            margin-right: 8px;
            background-image: url(${splashLeft});
        }
        ::after {
            margin-left: 8px;
            background-image: url(${splashRight});
        }
    }
`

export default HeaderDecor
